import { defaultClient } from '@mint-sdk/api-core';

import {
  getCategoriesQuerySchema,
  getCategoriesResponseSchema,
  getOldCategoriesResponseSchema,
} from '../shared/schemas/index.js';

// MINT 2.0 Categories API Endpoints
export const listQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/categories?cache=skip' as const,
  method: 'GET',
  responseSchema: getCategoriesResponseSchema,
  querySchema: getCategoriesQuerySchema,
  processResponse(data) {
    return data;
  },
});

// Mint Categories API Endpoints
export const listOldQueryOptions = defaultClient.query({
  url: 'authentication/v1/categories/' as const,
  method: 'GET',
  responseSchema: getOldCategoriesResponseSchema,
  querySchema: getCategoriesQuerySchema,
  processResponse(data) {
    return data;
  },
});
